import ArrowDown from '@mui/icons-material/KeyboardArrowDown';
import ArrowUp from '@mui/icons-material/KeyboardArrowUp';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import * as React from 'react';

export default function SeeMoreDescription({
  maxLines = 3,
  buttonPosition = 'end',
  buttonTextFolded = 'See more',
  buttonTextExtended = 'See less',
  description,
  wrapper,
  title,
}: {
  maxLines?: number;
  buttonPosition?: 'start' | 'end';
  buttonTextFolded?: string;
  buttonTextExtended?: string;
  description: string;
  title?: string;
  wrapper?: (children: any) => JSX.Element;
}) {
  const [seeMore, setSeeMore] = React.useState(false);
  const [lines, setLines] = React.useState(0);
  const showButton = lines > maxLines;

  const descriptionRef = React.useRef<HTMLElement>();

  React.useEffect(() => {
    const element = descriptionRef.current;
    if (!element) return;

    const divHeight = element.offsetHeight;
    const lineHeight = parseInt(
      element.style.lineHeight || window.getComputedStyle(element, null).getPropertyValue('line-height')
    );
    const lines = divHeight / lineHeight;

    setLines(lines);
  }, []);

  const Wrapper = ({ wrapper, children }: { wrapper: any; children: any }) => (wrapper ? wrapper(children) : children);

  return (
    <Stack>
      <Wrapper wrapper={wrapper}>
        {title && (
          <Typography variant="subtitle1" sx={{ width: 'fit-content' }} color="#212121">
            {title}
          </Typography>
        )}
        {/* Typescript is complaining about ref property but the documentation says: 
            "The ref is forwarded to the root element." */}
        {/* @ts-expect-error */}
        <Typography
          ref={descriptionRef}
          variant="body2"
          color="#212121"
          sx={
            !seeMore && showButton
              ? {
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: maxLines,
                  WebkitBoxOrient: 'vertical',
                }
              : {}
          }
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </Wrapper>

      {showButton && (
        <Stack width="100%" direction="row" alignItems="center" justifyContent={buttonPosition}>
          <Button
            variant="text"
            onClick={() => setSeeMore(!seeMore)}
            startIcon={seeMore ? <ArrowUp /> : <ArrowDown />}
            sx={{ width: 'fit-content', p: 0 }}
          >
            {seeMore ? buttonTextExtended : buttonTextFolded}
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
